import {
  ADD_USER,
  ADD_USER_FAILURE,
  ADD_USER_FREE_PREMIUM,
  ADD_USER_FREE_PREMIUM_FAILURE,
  ADD_USER_FREE_PREMIUM_SUCCESS,
  ADD_USER_SUCCESS,
  EDIT_USER,
  EDIT_USER_FAILURE,
  EDIT_USER_SUCCESS,
  SEND_ADMIN_MESSAGE,
  SEND_ADMIN_MESSAGE_FAILURE,
  SEND_ADMIN_MESSAGE_SUCCESS,
} from '../Actiontype';

const initialState = {
  AddorEdituserSuccess: false,
  AddorEdituserSuccessMessage: '',
  AddorEdituserFailure: false,
  AddorEdituserFailureMessage: '',
  UserDetails: null,
  SendAdminMessageSuccess: false,
  SendAdminMessageSuccessMessage: '',
  SendAdminMessageFailure: false,
  SendAdminMessageFailureMessage: '',
  AddFreePremiumSuccess: false,
  AddFreePremiumSuccessMessage: '',
  AddFreePremiumFailure: false,
  AddFreePremiumFailureMessage: '',
};
export default function UserManagementReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_USER:
      return {
        ...state,
        isFetching: true,
        AddorEdituserSuccess: false,
        AddorEdituserSuccessMessage: '',
        AddorEdituserFailure: false,
        AddorEdituserFailureMessage: '',
      };
    case ADD_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        AddorEdituserSuccess: true,
        AddorEdituserSuccessMessage: action.payload.Message,
      };
    case ADD_USER_FAILURE:
      return {
        ...state,
        isFetching: false,
        AddorEdituserFailure: true,
        AddorEdituserFailureMessage: action.payload.Message,
      };
    case EDIT_USER:
      return {
        ...state,
        isFetching: true,
        AddorEdituserSuccess: false,
        AddorEdituserSuccessMessage: '',
        AddorEdituserFailure: false,
        AddorEdituserFailureMessage: '',
      };
    case EDIT_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        AddorEdituserSuccess: true,
        AddorEdituserSuccessMessage: action.payload.Message,
      };
    case EDIT_USER_FAILURE:
      return {
        ...state,
        isFetching: false,
        AddorEdituserFailure: true,
        AddorEdituserFailureMessage: action.payload.Message,
      };
    case SEND_ADMIN_MESSAGE:
      return {
        ...state,
        isFetching: true,
        SendAdminMessageSuccess: false,
        SendAdminMessageSuccessMessage: '',
        SendAdminMessageFailure: false,
        SendAdminMessageFailureMessage: '',
      };
    case SEND_ADMIN_MESSAGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        SendAdminMessageSuccess: true,
        SendAdminMessageSuccessMessage: action.payload.Message,
      };
    case SEND_ADMIN_MESSAGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        SendAdminMessageFailure: true,
        SendAdminMessageFailureMessage: action.payload.Message,
      };
    case ADD_USER_FREE_PREMIUM:
      return {
        ...state,
        isFetching: true,
        AddFreePremiumSuccess: false,
        AddFreePremiumSuccessMessage: '',
        AddFreePremiumFailure: false,
        AddFreePremiumFailureMessage: '',
      };
    case ADD_USER_FREE_PREMIUM_SUCCESS:
      return {
        ...state,
        isFetching: false,
        AddFreePremiumSuccess: true,
        AddFreePremiumSuccessMessage: action.payload.Message,
      };
    case ADD_USER_FREE_PREMIUM_FAILURE:
      return {
        ...state,
        isFetching: false,
        AddFreePremiumFailure: true,
        AddFreePremiumFailureMessage: action.payload.Message,
      };
    default:
      return {
        ...state,
      };
  }
}
